/**
 * 组件选项信息
 * 根据此对象信息在画布中创建出完整的图表
 */
export interface IComponentOption {
  region: {
    regionKey: string; // region类型编号
    regionOption?: IRegionOption;
  };
  graphic: {
    graphicPath: string;
    graphicOption?: IGraphicOption;
  };
}

export interface IRegionOption {
  zIndex?: number;
  left?: number;
  top?: number;
  width: number; // note：图片的默认大小无需配置，当新增图片时，根据图片的实际大小设置region的维度
  height: number;

  [key: string]: any;
}

export interface IGraphicOption {
  id?: string; // 图表实例编号
  configSourceOption?: any;  // 配置源选项
  dataSourceConfigID?: string; // 数据源配置信息ID

  [key: string]: any;
}

export class RegionOption {
  constructor(private _regionKey: string, private _option: IRegionOption = {width: 300, height: 200}) {

  }

  get regionKey() {
    return this._regionKey;
  }

  get left() {
    return this._option.left;
  }

  get right() {
    return this._option.right;
  }

  get width() {
    return this._option.width;
  }

  get height() {
    return this._option.height;
  }

  get zIndex() {
    return this._option.zIndex;
  }

  get value() {
    return {
      regionKey: this._regionKey,
      regionOption: this._option
    };
  }
}

export class GraphicOption {
  constructor(private _graphicPath: string, private _option: IGraphicOption) {
  }

  get classID() {
    return this._graphicPath ? this._graphicPath.split('$')[1] : null;
  }

  set id(id: string) {
    this._option.id = id;
  }

  get id() {
    return this._option.id;
  }

  set configSourceOption(value) {
    this._option.configSourceOption = value;
  }

  get configSourceOption() {
    return this._option.configSourceOption;
  }

  set dataSourceConfigID(value) {
    this._option.dataSourceConfigID = value;
  }

  get dataSourceConfigID() {
    return this._option.dataSourceConfigID;
  }

  get value() {
    return {
      graphicPath: this._graphicPath,
      graphicOption: this._option
    };
  }
}

